import React from "react";
import { motion } from "framer-motion";
import {
  FaBriefcase,
  FaMoneyBillWave,
  FaGlobe,
  FaClock,
  FaUsers,
  FaRocket,
} from "react-icons/fa";

// Анимация заголовка (плавное появление сверху)
const titleVariants = {
  hidden: { opacity: 0, y: -10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

// Анимация элементов списка (плавное появление с задержкой)
const itemVariants = {
  hidden: { opacity: 0 },
  visible: (i) => ({
    opacity: 1,
    transition: { duration: 0.5, ease: "easeOut", delay: i * 0.2 },
  }),
};

function TrafficArbitrage() {
  const items = [
    {
      icon: <FaBriefcase className="arbitrage__icon" />,
      text: "<strong>Без офісу та начальника</strong> — ти працюєш коли і де маєш бажання, сам вирішуєш, скільки заробляти.",
    },
    {
      icon: <FaClock className="arbitrage__icon" />,
      text: "<strong>Швидкі гроші</strong> — перші заробітки можливо отримати вже до 7 днів після старту.",
    },
    {
      icon: <FaMoneyBillWave className="arbitrage__icon" />,
      text: "<strong>Не потрібен свій товар</strong> — ти просто приводиш клієнтів і отримуєш за це гроші.",
    },
    {
      icon: <FaGlobe className="arbitrage__icon" />,
      text: "<strong>Повністю онлайн</strong> — робота з будь-якої точки світу, потрібен тільки: ноутбук, телефон, інтернет та бажання.",
    },
    {
      icon: <FaUsers className="arbitrage__icon" />,
      text: "<strong>Безліміт у заробітку</strong> — дохід залежить тільки від тебе. Хтось заробляє 30-50 тис. грн на місяць, а хтось — 50 000 грн і більше.",
    },
    {
      icon: <FaRocket className="arbitrage__icon" />,
      text: "<strong>Можливо почати без грошей</strong> — ми навчимо стратегії, за якою можна запускатися без бюджету, ваші витрати будуть входити тільки на матеріал для запуску.",
    },
  ];

  return (
    <section className="arbitrage" id="arbitrage">
      <motion.h2
        className="arbitrage__title"
        variants={titleVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.5 }}
      >
        Чому <span>арбIтраж трафIку</span> — найкраща можливIсть для{" "}
        <span>новачкIв</span>?{" "}
        <a href="" className="arbitrage__cta">
          <span className="arbitrage__cta-text">ПРИЄДНАТИСЬ ДО НАС</span>
          <span className="arbitrage__cta-plus">+</span>
        </a>
      </motion.h2>

      <div className="arbitrage__list">
        {items.map((item, index) => (
          <motion.div
            key={index}
            className="arbitrage__item"
            variants={itemVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={index}
          >
            {item.icon}
            <p dangerouslySetInnerHTML={{ __html: item.text }} />
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default TrafficArbitrage;

// import React from "react";
// import { motion } from "framer-motion";
// import {
//   FaBriefcase,
//   FaMoneyBillWave,
//   FaGlobe,
//   FaClock,
//   FaUsers,
//   FaRocket,
// } from "react-icons/fa";

// // Анимация заголовка
// const titleVariants = {
//   hidden: { opacity: 0, y: -20 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.6, ease: "easeOut" },
//   },
// };

// // Контейнер списка — отвечает за stagger-анимацию
// const listVariants = {
//   hidden: {},
//   visible: {
//     transition: { staggerChildren: 0.2 }, // Задержка между элементами
//   },
// };

// // Анимация карточек (чередование направлений)
// const itemVariants = (index) => ({
//   hidden: {
//     opacity: 0,
//     x: index % 2 === 0 ? -100 : 100, // Чередуем направление (влево-вправо)
//   },
//   visible: {
//     opacity: 1,
//     x: 0,
//     transition: { duration: 0.6, ease: "easeOut" },
//   },
// });

// const cards = [
//   {
//     icon: <FaBriefcase className="arbitrage__icon" />,
//     text: "Без офісу та начальника — ти працюєш коли і де маєш бажання, сам вирішуєш, скільки заробляти.",
//   },
//   {
//     icon: <FaClock className="arbitrage__icon" />,
//     text: "Швидкі гроші — перші заробітки можливо отримати вже до 7 днів після старту.",
//   },
//   {
//     icon: <FaMoneyBillWave className="arbitrage__icon" />,
//     text: "Не потрібен свій товар — ти просто приводиш клієнтів і отримуєш за це гроші.",
//   },
//   {
//     icon: <FaGlobe className="arbitrage__icon" />,
//     text: "Повністю онлайн — робота з будь-якої точки світу, потрібен тільки ноутбук, телефон, інтернет та бажання.",
//   },
//   {
//     icon: <FaUsers className="arbitrage__icon" />,
//     text: "Безліміт у заробітку — дохід залежить тільки від тебе. Хтось заробляє 30-50 тис. грн на місяць, а хтось — 50 000 грн і більше.",
//   },
//   {
//     icon: <FaRocket className="arbitrage__icon" />,
//     text: "Можливо почати без грошей — ми навчимо стратегії, за якою можна запускатися без бюджету, ваші витрати будуть входити тільки на матеріал для запуску.",
//   },
// ];

// function TrafficArbitrage() {
//   return (
//     <section className="arbitrage" id="arbitrage">
//       <motion.h2
//         className="arbitrage__title"
//         variants={titleVariants}
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: false, amount: 0.5 }}
//       >
//         Чому <span>арбIтраж трафIку</span> — найкраща можливIсть для{" "}
//         <span>новачкIв</span>?{" "}
//         <a href="#contact" className="arbitrage__cta">
//           <span className="arbitrage__cta-text">ПРИЄДНАТИСЬ ДО НАС</span>
//           <span className="arbitrage__cta-plus">+</span>
//         </a>
//       </motion.h2>

//       <motion.div
//         className="arbitrage__list"
//         variants={listVariants}
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: false, amount: 0.3 }}
//       >
//         {cards.map((card, index) => (
//           <motion.div
//             key={index}
//             className="arbitrage__item"
//             variants={itemVariants(index)}
//           >
//             {card.icon}
//             <p>
//               <strong>{card.text.split(" — ")[0]}</strong> —{" "}
//               {card.text.split(" — ")[1]}
//             </p>
//           </motion.div>
//         ))}
//       </motion.div>
//     </section>
//   );
// }

// export default TrafficArbitrage;
